module.exports = __webpack_public_path__ + "img/about_us_hero_mobile.6bf2151f.jpg";